(function () {
    const yela_modals = $('.cards-yela-modals');
    yela_modals.hide();
}());


$(document).ready(() => {

    // Open Modals

    const yela_opens = $('.card-ys');

    $.each(yela_opens, function () {

        const card = $(this).attr('data-yela-modal');

        $(this).click(function () {

            const modal = $(`#${card}`);
            $('body').addClass('o-hidden-y');
            modal.show();
            modal.children('.cards-yela-modals__box').addClass('active');
            modal.addClass('active');

        });

    });

    // Events Modal

    const yela_modals = $('.cards-yela-modals');

    $.each(yela_modals, function () {

        const modal_close = $(this).children('.cards-yela-modals__box').children('.modal-close');
        const categories = $(this).children('.cards-yela-modals__box').children('.modal-categories').children('.modal-categories__category');

        const outside = $(this).children('.cards-yela-modals__box');

        $(this).click(function (e) {

            if (!outside.is(e.target) && outside.has(e.target).length === 0) {

                $(this).removeClass('active');
                $(this).children('.cards-yela-modals__box').removeClass('active');
                setTimeout(() => {
                    $('body').removeClass('o-hidden-y');
                    $(this).hide();
                }, 500);

            }

        });

        modal_close.click(function () {

            const modal = $(this).parent('.cards-yela-modals__box').parent('.cards-yela-modals');
            modal.removeClass('active');
            modal.children('.cards-yela-modals__box').removeClass('active');
            setTimeout(() => {
                $('body').removeClass('o-hidden-y');
                modal.hide();
            }, 500);

        });

        $.each(categories, function (index) {

            const category = $(this).next('.modal-categories__category-details');
            const icon = $(this).children('.c-icon');

            if (index === 0) {

                category.slideToggle();
                icon.addClass('active');

            }

            $(this).click(function () {

                (icon.hasClass('active')) ? icon.removeClass('active') : icon.addClass('active');

                category.slideToggle(500);

            });

        });

    });

});
